window.scrollTarifTuslahLeft = scrollTarifTuslahLeft;
window.scrollTarifTuslahRight = scrollTarifTuslahRight;
export function showModalTarifTuslah() {
    const modal = document.getElementById('modalTarifTuslah');
    if (modal) {
        modal.classList.remove('hidden');
    }
}

export function hideModalTarifTuslah() {
    const modal = document.getElementById('modalTarifTuslah');
    if (modal) {
        modal.classList.add('hidden');
    }
}

export function scrollTarifTuslahLeft() {
    const container = document.getElementById('TarifTuslahScrollContainer');
    if (container) container.scrollBy({ left: -300, behavior: 'smooth' });
}

export function scrollTarifTuslahRight() {
    const container = document.getElementById('TarifTuslahScrollContainer');
    if (container) container.scrollBy({ left: 300, behavior: 'smooth' });
}
